(function (process,global,Buffer,__argument0,__argument1,__argument2,__argument3,__filename,__dirname){
var selectizeAjaxSearch = require('./selectize-ajax-search')()

module.exports = function () {
  this.$('.ec-simple-select').selectize()

  this.$('.ec-simple-data-select').selectize(
    { valueField: '_id'
    , labelField: 'name'
    , searchField: 'name'
    , create: false
    })

  this.$('.ec-status-select').selectize(
    { onChange: function (value) {
      this.$wrapper.closest('.ec-input-list-item').attr('data-status', value)
    }
  })

  this.$('.ec-multiple-data-select').selectize(
    { valueField: '_id'
    , labelField: 'name'
    , searchField: 'name'
    , create: false
    , persist: false
    , maxItems: null
    })

  this.$('.ec-multiple-create').selectize(
    { create: true
    , persist: false
    , maxItems: null
    }
  )

  this.$('.ec-multiple-select').selectize(
    { persist: false
    , maxItems: null
    }
  )

  this.$('.ec-ajax-select').selectize(
    { valueField: '_id'
    , labelField: 'name'
    , searchField: 'name'
    , create: false
    , load: selectizeAjaxSearch
  })

  this.$('.ec-ajax-select-create').selectize(
    { valueField: '_id'
    , labelField: 'name'
    , searchField: 'name'
    , persist: false
    , create: function (value) { return { _id: value, name: value } }
    , load: selectizeAjaxSearch
    }
  )

  this.$('.ec-multiple-select-remote').selectize(
    { persist: false
    , maxItems: null
    , valueField: '_id'
    , labelField: 'name'
    , searchField: 'name'
    , create: false
    , load: selectizeAjaxSearch
    }
  )

  this.$('.ec-multiple-select-remote-create').selectize(
    { persist: false
    , maxItems: null
    , valueField: '_id'
    , labelField: 'name'
    , searchField: 'name'
    , create: function (value) { return { _id: value, name: value } }
    , load: selectizeAjaxSearch
    }
  )

  // FIXME: sometimes selectize controls display as inline block and look rubbish,
  // this hack fixes that, but shouldn't be necessary
  this.$el.on('shown.bs.modal', hack.bind(this))
  setTimeout(hack.bind(this), 0)
}

function hack () {
  this.$('.selectize-control:visible').css('display', 'block')
}

}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {},require("buffer").Buffer,arguments[3],arguments[4],arguments[5],arguments[6],"/admin/source/js/app/lib/selectize-delegate.js","/admin/source/js/app/lib")
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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